/*
--------------------------------------------------------------------------------
Module in charge of form submitting, preventing double submit, etc.
Further general/common functionality of forms should also be moved here
to unify and simplify the handling of that functionality
--------------------------------------------------------------------------------

<![CDATA[

*/

(function ($) {

    'use strict';

    if (typeof ori != "object") return;

    var self,
        SEL_FORM = ".js-form",
        SEL_PREVENT_REPEAT = ".js-prevent-repeat",
        CLASS_SPINNER_LOADING = "k-loading",
        LOADING_ICON = ".k-icon.k-loading.remote-request",
        LOADING_ICON_TEMPLATE = '<span class="k-icon k-loading remote-request"></span>',

        DATA_FORM_OPTIONS = "form-options",
        DATA_BUTTON_OPTIONS = "button-options",
        DATA_IN_PROGRESS = "in-progress",

        DATA_DISABLE_INPUTS = "disable-inputs",
        DATA_APPLY_OVERLAY = "apply-overlay",
        DATA_BUTTON_SELECTOR = "button-selector",
        DATA_BUTTON_APPLY_CLASS = "button-apply-class",
        DATA_BUTTON_APPLY_SPINNER = "button-apply-spinner",
        DATA_BUTTON_DISABLE = "button-disable",
        DATA_USE_POST = "use-post",
        DATA_CALLBACK_BEFORE = "callback-before",
        DATA_CALLBACK_DATA = "callback-data",
        DATA_CALLBACK_SUCCESS = "callback-success",
        DATA_CALLBACK_ERROR = "callback-error",
        DATA_CALLBACK_ALWAYS = "callback-always";

    ori.addModule("forms", {
        /* ori.forms.options is used to set "global" form options for the page that is currently loaded.
         * It saves client-side time and provides shorter html markup for forms.
         * If there are more forms on a page, individual per-form options may be set via form's data attributes listed above.
         * In these attributes, only the settings which differ from the "global" options need to be set.
         */
        options: {
            disableInputs: false,       // bool; indicates whether or not to disable all input fields on the form to prevent user changes during request.
            applyOverlay: false,        // bool; indicates whether or not to apply spinner overlay to the whole page for the duration of the request.
            buttonSelector: "button[type=submit]",  // string; selector to find the submit button within the form; if empty, no button will be manipulated.
            buttonApplyClass: "",       // string; class(es) to apply to the submit button for the duration of the request. If empty, ignored.
            buttonApplySpinner: true,   // bool; indicates whether or not to apply spinner to the submit button for the duration of the request.
            buttonDisable: true,        // bool; indicates whether or not to disable the submit button for the duration of the request.
            usePost: false,             // bool; if true, the form will be submitted via browser's POST mechanism instead of AJAX. In such case, only callbackBefore gets called, obviously.
            callbackBefore: null,       // function($form); must return bool or string. Called before initiating AJAX/POST request - if falsy value (empty string, false, ...) returned, no request is executed.
                                        //                  If true is returned, the default form action is requested. If nonempty string is returned, it will be used as the request URL.
            callbackData: null,         // function($form); must return serialized form data. The returned value is fed to AJAX request.
            callbackSuccess: null,      // function($form, {request, status, result, success:true}); return value ignored. Called upon successful return from AJAX.
            callbackError: null,        // function($form, {request, status, result, success:false}); return value ignored. Called upon AJAX failure.
            callbackAlways: null,        // function($form, {request, status, result, success}); return value ignored. Called always upon AJAX completion.
            sel: {
                form: SEL_FORM
            }
        },

        init: function (options) {
            self.setOptions(options);
            registerHandlers();
        },

        toggleInputWidgets: function ($form, enable) {
            $form.find('.k-widget').each(function() {
                var widget = kendo.findWidgetInstance(this);
                if (widget && typeof widget.enable == "function")
                    widget.enable(enable);
                else {
                    $(this).find('input').prop('disabled', !enable);
                }
            });
        },

        toggleLoadingIcon: function ($input, visible) {
            var $wrapper = kendo.findWrapper($input),
                hasWrapper = ($wrapper && $wrapper.length),
                $loading = (hasWrapper ? $wrapper : $input).find(LOADING_ICON).toggle(visible);
            if (visible && !$loading.length)
                (hasWrapper ? $wrapper : $input).append($(LOADING_ICON_TEMPLATE));
        },

        toggleButton: function($button, enable) {
            if ( $button.length == 0 || (typeof $button.data(DATA_IN_PROGRESS) === "undefined") === enable )
                return false;

            if (enable) {
                $button.removeData(DATA_IN_PROGRESS);
            } else {
                $button.data(DATA_IN_PROGRESS, "true");
            }

            var options = getButtonOptions($button);
            if (options.buttonApplyClass !== "") {
                $button.toggleClass(buttonApplyClass, !enable);
            }
            if (options.buttonApplySpinner) {
                if (enable) {
                    ori.spinner.removeFrom($button, CLASS_SPINNER_LOADING);
                } else {
                    ori.spinner.applyTo($button, { cssClass: CLASS_SPINNER_LOADING, halign: 'right' });
                }
            }
            if (options.buttonDisable) {
                $button.prop("disabled", !enable);
            }
            return true;
        }

    });

    function registerHandlers() {
        var $document = $(document);

        $document.on(self.eventString('submit'), self.options.sel.form, function (e) {
            var $form = $(this),
                $button = null,
                options,
                method,
                action = true,
                data,
                success = true;

            if (typeof $form.data(DATA_IN_PROGRESS) !== "undefined") { // a request is already in progress => prevent repeating it
                e.preventDefault();
                return false;
            }
            options = getFormOptions($form);
            if (typeof options.callbackBefore === "function" && !(action = options.callbackBefore($form))) {
                e.preventDefault();
                return false;
            }

            $form.data(DATA_IN_PROGRESS, "true");
            if (options.buttonSelector !== "") {
                $button = $form.find(options.buttonSelector);
                if (options.buttonApplyClass !== "") {
                    $button.addClass(buttonApplyClass);
                }
                if (options.buttonApplySpinner) {
                    ori.spinner.applyTo($button, { cssClass: CLASS_SPINNER_LOADING, halign: 'right' });
                }
                if (options.buttonDisable) {
                    $button.prop("disabled", true);
                }
            }
            if (options.applyOverlay) {
                ori.spinner.applyOverlayTo();
            }

            if (options.usePost) {
                return true;
            }
            e.preventDefault();
            if (typeof options.callbackData === "function") {
                data = options.callbackData($form);
            } else {
                data = new FormData($form[0]);
                if (!data) {
                    data = $form[0].serialize();
                }
            }
            // inputs may only be disabled after form serialization, otherwise they will not get serialized
            if (options.disableInputs) {
                self.toggleInputWidgets($form, false);
            }

            method = $form.attr("method");
            method = typeof method === "string" ? method.toUpperCase() : "POST";
            if (typeof action !== "string") {
                action = $form.attr("action");
            }
            $.ajax({
                url: action,
                data: data,
                cache: false,
                contentType: false,
                processData: false,
                type: method
            })
            .done(function (data, status, request) {
                if (typeof options.callbackSuccess === "function") {
                    options.callbackSuccess($form, {
                        request: request,
                        status: status,
                        result: data,
                        success: true
                    });
                }
            })
            .fail(function (request, status, error) {
                success = false;
                if (typeof options.callbackError === "function") {
                    options.callbackError($form, {
                        request: request,
                        status: status,
                        result: error,
                        success: false
                    });
                }
            })
            .always(function (data, status, error) {
                if (options.applyOverlay) {
                    ori.spinner.removeOverlayFrom();
                }
                if (options.disableInputs) {
                    self.toggleInputWidgets($form, true);
                }
                if ($button) {
                    if (options.buttonApplyClass !== "") {
                        $button.removeClass(buttonApplyClass);
                    }
                    if (options.buttonApplySpinner) {
                        ori.spinner.removeFrom($button, CLASS_SPINNER_LOADING);
                    }
                    if (options.buttonDisable) {
                        $button.prop("disabled", false);
                    }
                }
                $form.removeData(DATA_IN_PROGRESS);

                if (typeof options.callbackAlways === "function") {
                    // here we leverage from the feature stated in jQuery documentation:
                    // "When the Deferred is resolved or rejected, callbacks are executed in the order they were added"
                    // so success will already have been set to the correct value by the time we get here
                    var args = {
                        status: status,
                        success: success,
                        request: error,
                        result: data
                    }
                    if (!success) {
                        args.request = data;
                        args.result = error;
                    }
                    options.callbackAlways($form, args);
                }
            });
        });

        $document.on(self.eventString('click'), SEL_PREVENT_REPEAT, function (e) {
            if (self.toggleButton($(this), false)) {
                return true;
            }
            e.preventDefault();
            return false;
        });
    }

    function getFunctionFromString(fname) {
        if (typeof fname !== "string" || fname === "")
            return null;
        var parts = fname.split('.'),
            context = window;
        for (var i = 0, len = parts.length; i < len; i++) {
            if (typeof context[parts[i]] === "undefined")
                return null;
            context = context[parts[i]];
        }
        return typeof context === 'function' ? context : null;
    }

    function getFormOptions($form) {
        var options = $form.data(DATA_FORM_OPTIONS),
            dataval;
        if (typeof options === "object")
            return options;

        options = {};
        dataval = $form.data(DATA_DISABLE_INPUTS);
        options.disableInputs = typeof dataval !== "undefined" ? dataval == true : self.options.disableInputs;
        dataval = $form.data(DATA_APPLY_OVERLAY);
        options.applyOverlay = typeof dataval !== "undefined" ? dataval == true : self.options.applyOverlay;
        dataval = $form.data(DATA_BUTTON_SELECTOR);
        options.buttonSelector = typeof dataval !== "undefined" ? dataval : self.options.buttonSelector;
        dataval = $form.data(DATA_BUTTON_APPLY_CLASS);
        options.buttonApplyClass = typeof dataval !== "undefined" ? dataval : self.options.buttonApplyClass;
        dataval = $form.data(DATA_BUTTON_APPLY_SPINNER);
        options.buttonApplySpinner = typeof dataval !== "undefined" ? dataval == true : self.options.buttonApplySpinner;
        dataval = $form.data(DATA_BUTTON_DISABLE);
        options.buttonDisable = typeof dataval !== "undefined" ? dataval == true : self.options.buttonDisable;
        dataval = $form.data(DATA_USE_POST);
        options.usePost = typeof dataval !== "undefined" ? dataval == true : self.options.usePost;
        dataval = $form.data(DATA_CALLBACK_BEFORE);
        options.callbackBefore = typeof dataval !== "undefined" ? getFunctionFromString(dataval) : self.options.callbackBefore;
        dataval = $form.data(DATA_CALLBACK_DATA);
        options.callbackData = typeof dataval !== "undefined" ? getFunctionFromString(dataval) : self.options.callbackData;
        dataval = $form.data(DATA_CALLBACK_SUCCESS);
        options.callbackSuccess = typeof dataval !== "undefined" ? getFunctionFromString(dataval) : self.options.callbackSuccess;
        dataval = $form.data(DATA_CALLBACK_ERROR);
        options.callbackError = typeof dataval !== "undefined" ? getFunctionFromString(dataval) : self.options.callbackError;
        dataval = $form.data(DATA_CALLBACK_ALWAYS);
        options.callbackAlways = typeof dataval !== "undefined" ? getFunctionFromString(dataval) : self.options.callbackAlways;

        $form.data(DATA_FORM_OPTIONS, options);
        return options;
    }

    function getButtonOptions($button) {
        var options = $button.data(DATA_BUTTON_OPTIONS),
            dataval;
        if (typeof options === "object")
            return options;

        options = {};
        dataval = $button.data(DATA_BUTTON_APPLY_CLASS);
        options.buttonApplyClass = typeof dataval !== "undefined" ? dataval : self.options.buttonApplyClass;
        dataval = $button.data(DATA_BUTTON_APPLY_SPINNER);
        options.buttonApplySpinner = typeof dataval !== "undefined" ? dataval == true : self.options.buttonApplySpinner;
        dataval = $button.data(DATA_BUTTON_DISABLE);
        options.buttonDisable = typeof dataval !== "undefined" ? dataval == true : self.options.buttonDisable;

        $button.data(DATA_BUTTON_OPTIONS, options);
        return options;
    }

    self = ori.forms;
    $(function () { ori.forms.init(); });

})(jQuery);

/* ]]> */